/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-21 18:30:40
 */

import {Component,Prop,Watch} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import DayReportApi, {DayReportDOI} from "./api/dayReportApi";
import DayReportService from "./service/dayReportService";
import './dayReport.less';
import { createBEM, createNamespace } from 'src/util/bem';
import Tab from 'src/components/tab/tab';
import QueryForm from 'src/components/queryForm/queryForm';
import Button from 'src/types/iview/Button';
import FileUtil from 'src/util/fileUtil';
import MenuBtn from 'src/pages/layout/components/menuBtn';

let bem = createBEM('single-station-report');

@Component({name: 'day-report'})
export default class DayReport extends BasicSearchPage<DayReportService, DayReportDOI.RowDataI, DayReportDOI.QueryRowDataParamsI> {

    @Prop({
		type: String
	})
	mn!: string

    className = createNamespace('pa0');
    pageShow = false
    currentDataType: string = '日报'
    dataType: {name: string, value: string}[] = [{name: '日报', value: '日报'},{name: '周报', value: '周报'},{name: '月报', value: '月报'},{ name: '年报', value: '年报' },]

    tabChange(v) {
        this.$emit('change', v)
        this.columnDefs = this.service.createColumns()
        this.queryFormData = this.service.creatQueryForm()
        this.search()
    }
    @Watch('mn')
    stationChange() {
        this.search()
    }
    async export() {
        let {code, data} = await DayReportApi.export(this.currentDataType)
        if(code ===0) {
            FileUtil.download(data.download_url)
        }
    }

    renderQuery(h) {
		return <div class={bem('query')}>
            <Tab dataSource={this.dataType} v-model={this.currentDataType} on-change={this.tabChange.bind(this)}></Tab>
            <div class={bem('query-form')}>
                <QueryForm ref="queryForm" dataSource={this.queryFormData} on-search={this.search} showClear={false}/>
            </div>
            {/* <Button class={createNamespace('mb5')} type="info" on-click={this.export.bind(this)}>导出</Button> */}

        </div>
    }

    @override
    renderHead(h) {
        return <MenuBtn class={createNamespace('mb10')} on-zoomFlag={this.zoomFlag}></MenuBtn>
    }
    
    zoomFlag(h) {
        this.$emit('zoomFlag', h)
        if(h == false){
           this.search()
        }
    }
    @override
    loadService() {
        this.service = new DayReportService(this)
    }
}